// extracted by mini-css-extract-plugin
export default {"wrap":"hH-z","fullWidth":"iH-z","hideOnDesktop":"jH-z","content":"kH-z","hasOpenedNav":"lH-z","crumbsList":"mH-z","dropdownsWrap":"nH-z"};